import React, { useState } from "react"
import { Appheader } from "../header/header-component"
import { VoiceRecorder } from "react-voice-recorder-player"
import {
    DialogBox,
    WaitingDialog,
    DialogBoxTwoOption,
    GenericDialogBox,
} from "../dialog/dialog-component"
import { AppSectionBoxComponent } from "../components/section-box/section-box-component"
import { AppSpinner } from "../spinner/spinner-component"
import { AppSessionToolbar } from "../session-toolbar/session-toolbar-component"
import { TranscriptsComponentClient } from "../transcripts/transcripts-component_client"
import { adjDim, isLargeScreen } from "../myhooks/custom-hooks"
import SessionQRCode from "../feedback-form/session-qrcode";
import FacilitationPanel from "../components/facilitation/FacilitationPanel";
import PostDiscussionArtifacts from "../components/facilitation/PostDiscussionArtifacts";
import DiscussionPulsePanel from "../components/discussion-pulse";

import style from "./byod-join.module.css"
import style2 from "../pod-details/pod.module.css"
import style4 from "../components/context-menu/context-menu.module.css"
import style5 from "../sessions/sessions.module.css"
import Checkmark from "@assets/img/checkmark.svg"
import { AppContextMenu } from "../components/context-menu/context-menu-component"

function ByodJoinPage(props) {
    // console.log(props, 'props')
    return (
        <>
            {(props.currentForm === "gottoselectedtranscript" &&
                Object.keys(props.currentTranscript) && (
                    <TranscriptsComponentClient
                        sessionDevice={props.sessionDevice}
                        transcriptIndex={props.currentTranscript.id}
                        setParentCurrentForm={props.setCurrentForm}
                    />
                )) ||
                (props.currentForm === "gototranscript" && (
                    <TranscriptsComponentClient
                        sessionDevice={props.sessionDevice}
                        transcriptIndex={undefined}
                        setParentCurrentForm={props.setCurrentForm}
                    />
                )) || (
                    <div className="main-container">
                        <Appheader
                            title={props.pageTitle}
                            leftText={false}
                            rightText={"Option"}
                            rightEnabled={
                                props.joinwith === "Video" ||
                                props.joinwith === "Videocartoonify"
                                    ? true
                                    : false
                            }
                            rightTextClick={() =>
                                props.joinwith === "Video" ||
                                props.joinwith === "Videocartoonify"
                                    ? props.openDialog("Options")
                                    : props.openDialog("")
                            }
                            nav={() => props.navigateToLogin()}
                        />
                        {/* Students never see the legacy join form. They arrive
                            here from StudentRightPanel with passcode + name in
                            the URL, the auto-submit useEffect handles join, and
                            we show a small Joining indicator while it runs. */}
                        {!props.connected && props.isStudentRecorder && (
                            <div className="@container relative box-border flex grow flex-col items-center justify-center overflow-y-auto text-center p-8">
                                <div className="font-sans text-base/loose font-medium text-[#727278]">
                                    Joining your group…
                                </div>
                                <div className="mt-2 font-sans text-xs/normal text-[#9ca3af]">
                                    Setting up the connection. You may be asked for microphone permission.
                                </div>
                            </div>
                        )}
                        {!props.connected && !props.isStudentRecorder && (
                            <React.Fragment>
                                <div className="@container relative box-border flex grow flex-col items-center justify-between overflow-y-auto text-center">
                                    <div>
                                        <div className="my-1.5 font-sans text-base leading-5 font-normal text-[#727278]">
                                            Please type your name and passcode
                                            to join a discussion.
                                        </div>
                                        <div className="my-1.5 font-sans text-xs leading-5 font-normal text-[#727278]">
                                            If rejoining a discussion, type the
                                            same name you used previously.
                                        </div>
                                    </div>
                                    <div>
                                        <div>Device Name:</div>
                                        <input
                                            className="text-box small-section"
                                            id="name"
                                            placeholder="Name"
                                        />
                                        <div>Passcode:</div>
                                        <input
                                            className="text-box small-section"
                                            id="passcode"
                                            value={props.pcode}
                                            placeholder="Passcode (4 characters)"
                                            onInput={(event) =>
                                                props.changeTouppercase(event)
                                            }
                                        />
                                        {props.wrongInput
                                            ? "Your password must be 4 characters long."
                                            : ""}
                                        {/* Speaker identification mode — shown BEFORE the
                                            collaborator count so the user's choice determines
                                            whether the count input is needed at all. Default
                                            is Automatic (Deepgram diarization), which has no
                                            count parameter — so the collaborators field stays
                                            hidden unless the user opts into Voice Fingerprint. */}
                                        <div>Speaker Identification:</div>
                                        <select
                                            id="speakerMode"
                                            className="dropdown small-section"
                                            value={props.speakerMode}
                                            onChange={(e) => props.setSpeakerMode(e.target.value)}
                                        >
                                            <option value="auto">Automatic (no enrollment)</option>
                                            <option value="enrolled">Voice Fingerprint</option>
                                        </select>
                                        {props.speakerMode === "enrolled" && (
                                            <>
                                                <div>Number of Collaborators:</div>
                                                <select
                                                    id="collaborators"
                                                    className="dropdown small-section"
                                                    defaultValue="4"
                                                >
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                </select>
                                            </>
                                        )}
                                        <div>Join With:</div>
                                        <select
                                            id="joinwith"
                                            className="dropdown small-section"
                                        >
                                            <option value="Audio">Audio</option>
                                            {/*<option value="Video">Video</option>
                    <option value="Videocartoonify">Video(Cartoon)</option>*/}
                                        </select>
                                        <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: "12px 0 4px", cursor: "pointer", fontSize: "14px" }}>
                                            <input
                                                type="checkbox"
                                                checked={props.facilitationEnabled}
                                                onChange={(e) => props.setFacilitationEnabled(e.target.checked)}
                                                style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                            />
                                            Enable Discussion Facilitator
                                        </label>
                                    </div>
                                    <button
                                        className="wide-button"
                                        onClick={() => {
                                            const mode = document.getElementById("speakerMode").value.trim();
                                            // The collaborators select only renders when mode
                                            // is "enrolled" — guard the DOM read so this
                                            // doesn't throw in auto mode. The backend ignores
                                            // the count in auto mode anyway (the frontend
                                            // overrides it to 0 before sending).
                                            const collabEl = document.getElementById("collaborators");
                                            const collabCount = collabEl
                                                ? parseInt(collabEl.value.trim(), 10) || 0
                                                : 0;
                                            props.verifyInputAndAudio(
                                                document.getElementById("name").value.trim(),
                                                document.getElementById("passcode").value.trim(),
                                                document.getElementById("joinwith").value.trim(),
                                                collabCount,
                                                mode,
                                            );
                                        }}
                                    >
                                        Connect to Server
                                    </button>
                                    <div style={{ marginTop: 14, fontSize: "0.78rem", color: "#6b7280", textAlign: "center" }}>
                                        Not the recording device?{" "}
                                        <a
                                            href="/viewer"
                                            style={{ color: "#2563eb", textDecoration: "underline", fontWeight: 500 }}
                                        >
                                            Join as a viewer
                                        </a>
                                        {" "}instead (no mic needed).
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        {/* Students follow the auto-validate path: their voiceprint
                            is pushed by the auto-push useEffect and the speakers-
                            validated flag is flipped automatically. The legacy
                            enrollment screen below would briefly flash for them
                            in the gap between auto-push completing and
                            speakersValidated flipping — and worse, would strand
                            them if anything went wrong. The student fast-path
                            shows a lightweight "Setting up your voice…" indicator
                            instead. */}
                        {props.connected &&
                            props.authenticated &&
                            !props.speakersValidated &&
                            props.isStudentRecorder && (
                                <div className="@container relative box-border flex grow flex-col items-center justify-center overflow-y-auto text-center p-8">
                                    <div className="font-sans text-base/loose font-medium text-[#727278]">
                                        Setting up your voice…
                                    </div>
                                    <div className="mt-2 font-sans text-xs/normal text-[#9ca3af]">
                                        Loading your voiceprint into the discussion. This usually takes a second.
                                    </div>
                                </div>
                            )}
                        {props.connected &&
                            props.authenticated &&
                            !props.speakersValidated &&
                            !props.isStudentRecorder && (
                                <React.Fragment>
                                    <div className="@container relative box-border flex grow flex-col items-center justify-between overflow-y-auto text-center">
                                        <div className="w-[300px] px-2 sm:w-[400px] lg:w-3xl">
                                            <div className="my-1.5 font-sans text-base/loose font-medium text-[#727278]">
                                                Please add a Speaker Fingerprint
                                                for each speaker
                                            </div>
                                            <div className="my-1.5 font-sans text-xs/normal font-normal text-[#727278]">
                                                Each speaker must record and
                                                temporarily save a short 3-5
                                                second sample of their voice.
                                                This is used to track each
                                                speaker's metrics throughout a
                                                discussion and is deleted upon
                                                ending the discussion.
                                            </div>
                                        </div>
                                        <div className="mt-2 h-fit w-[300px] sm:w-[400px] lg:w-3xl">
                                            {!props.speakers && (
                                                <div
                                                    className={`${style["load-text"]} ${style["onload"]}`}
                                                >
                                                    Loading...
                                                </div>
                                            )}
                                            {props.speakers &&
                                                props.speakers.length === 0 && (
                                                    <div
                                                        className={
                                                            style[
                                                                "empty-speaker-list"
                                                            ]
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                style[
                                                                    "load-text"
                                                                ]
                                                            }
                                                        >
                                                            {" "}
                                                            No Speakers{" "}
                                                        </div>
                                                        <div
                                                            className={
                                                                style[
                                                                    "load-text-description"
                                                                ]
                                                            }
                                                        >
                                                            {" "}
                                                            Tap the button below
                                                            to add a speaker or
                                                            other button to join
                                                            automatically detect
                                                            speakers(less
                                                            accurate){" "}
                                                        </div>
                                                    </div>
                                                )}
                                            {props.speakers.map(
                                                (speaker, count) => (
                                                    <div
                                                        key={"speaker" + count}
                                                        className="my-3 flex flex-row items-center justify-between rounded-md border px-2 py-2"
                                                    >
                                                        {speaker.fingerprinted && (
                                                            <img
                                                                className="h-8 w-8"
                                                                alt="question"
                                                                src={Checkmark}
                                                            />
                                                        )}
                                                        <div
                                                            className={
                                                                style[
                                                                    "click-mask"
                                                                ]
                                                            }
                                                            onClick={() => {}}
                                                        ></div>
                                                        <div className="flew-row flex grow text-center">
                                                            <div className="grow font-sans text-lg/loose font-bold text-[#58585C]">
                                                                {speaker.alias}
                                                            </div>
                                                        </div>
                                                        <AppContextMenu
                                                            className={
                                                                style[
                                                                    "speaker-list-options"
                                                                ]
                                                            }
                                                        >
                                                            <div
                                                                className={`${style4["menu-item"]} ${style4["black"]}`}
                                                                onClick={() => {
                                                                    props.openForms(
                                                                        "fingerprintAudio",
                                                                        speaker,
                                                                    )
                                                                }}
                                                            >
                                                                Record
                                                                Fingerprint
                                                            </div>
                                                            <div
                                                                className={`${style4["menu-item"]} ${style4["black"]}`}
                                                                onClick={() => {
                                                                    props.openForms(
                                                                        "renameAlias",
                                                                        speaker,
                                                                    )
                                                                }}
                                                            >
                                                                Rename Alias
                                                            </div>
                                                        </AppContextMenu>
                                                    </div>
                                                ),
                                            )}
                                        </div>
                                        <div>
                                            <button
                                                className="wide-button"
                                                onClick={props.confirmSpeakers}
                                            >
                                                Join Discussion
                                            </button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        {props.connected &&
                            props.authenticated &&
                            props.speakersValidated && (
                                <>
                                    <div className="toolbar-view-container">
                                        {props.session ? (
                                            <AppSessionToolbar
                                                session={props.session}
                                                closingSession={
                                                    props.disconnect
                                                }
                                                fromClient={true}
                                                menus={[
                                                    {
                                                        title: "Group",
                                                        action: () =>
                                                            props.viewGroup(),
                                                    },
                                                    {
                                                        title: "Individual",
                                                        action: () =>
                                                            props.viewIndividual(),
                                                    },
                                                    {
                                                        title: "Comparison",
                                                        action: () =>
                                                            props.viewComparison(),
                                                    },
                                                ]}
                                            />
                                        ) : (
                                            <></>
                                        )}
                                        {/* === Group info bar: viewer code + count + end recording === */}
                                        {props.sessionDevice && props.viewerCode && props.currentForm !== 'ClosedSession' ? (
                                            <div style={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                padding: '10px 14px', margin: '8px 12px 0',
                                                background: '#f0f9ff', border: '1px solid #bae6fd',
                                                borderRadius: '8px',
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                                    <div>
                                                        <div style={{ fontSize: '0.68rem', color: '#0369a1', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 600 }}>
                                                            Group code
                                                        </div>
                                                        <div style={{
                                                            fontSize: '1.6rem', fontWeight: 700, color: '#0c4a6e',
                                                            fontFamily: 'ui-monospace, SFMono-Regular, monospace',
                                                            letterSpacing: '0.15em',
                                                        }}>
                                                            {props.viewerCode}
                                                        </div>
                                                    </div>
                                                    <div style={{ fontSize: '0.72rem', color: '#0369a1', maxWidth: 280, lineHeight: 1.4 }}>
                                                        Teammates: open{" "}
                                                        <strong style={{ fontFamily: 'ui-monospace, SFMono-Regular, monospace' }}>
                                                            {typeof window !== 'undefined' ? window.location.host : ''}/viewer
                                                        </strong>
                                                        {" "}and type this code to follow along and review the summary.
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <div style={{
                                                        fontSize: '0.75rem', color: '#075985', fontWeight: 500,
                                                        padding: '4px 10px', background: '#e0f2fe', borderRadius: 12,
                                                    }}>
                                                        {(props.viewerCount || 1)} device{(props.viewerCount || 1) === 1 ? '' : 's'} connected
                                                    </div>
                                                    {props.endRecording && (
                                                        <button
                                                            onClick={props.endRecording}
                                                            style={{
                                                                padding: '7px 14px', fontSize: '0.8rem', fontWeight: 600,
                                                                background: '#dc2626', color: '#fff', border: 'none',
                                                                borderRadius: 6, cursor: 'pointer',
                                                            }}
                                                        >
                                                            End recording
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}
                                        {/* === Primary discussion view: live transcript always.
                                            Blinc panel appears alongside only when facilitation is enabled. */}
                                        {props.sessionDevice ? (
                                            <div style={{
                                                display: 'flex', gap: '12px', padding: '8px 12px',
                                                height: 'calc(100vh - 200px)', minHeight: '300px',
                                            }}>
                                                {/* Left: Live transcript (shown in every recording session) */}
                                                <div style={{
                                                    flex: 2, display: 'flex', flexDirection: 'column',
                                                    background: '#fff', borderRadius: '8px',
                                                    border: '1px solid #e2e8f0', overflow: 'hidden',
                                                }}>
                                                    <div style={{
                                                        padding: '8px 14px', borderBottom: '1px solid #e2e8f0',
                                                        background: '#f8fafc', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'space-between',
                                                    }}>
                                                        <span style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1e293b' }}>
                                                            Live Transcript
                                                        </span>
                                                        <span style={{
                                                            fontSize: '0.68rem', color: '#ef4444', fontWeight: 500,
                                                            display: 'flex', alignItems: 'center', gap: '4px',
                                                        }}>
                                                            <span style={{
                                                                width: '6px', height: '6px', borderRadius: '50%',
                                                                background: '#ef4444', display: 'inline-block',
                                                                animation: 'pulse 2s infinite',
                                                            }}></span>
                                                            Recording
                                                        </span>
                                                    </div>
                                                    <div style={{
                                                        flex: 1, overflowY: 'auto', padding: '6px 0',
                                                    }}>
                                                        {props.transcripts && props.transcripts.length > 0 ? (
                                                            <>
                                                            {props.transcripts.map((t, i) => (
                                                                <div key={t.id || i} style={{
                                                                    padding: '4px 14px', borderBottom: '1px solid #f8fafc',
                                                                    fontSize: '0.82rem',
                                                                }}>
                                                                    <span style={{
                                                                        fontWeight: 600, fontSize: '0.7rem',
                                                                        color: t.speaker_tag === 'Blinc' ? '#16a34a' : '#6366f1',
                                                                        textTransform: 'uppercase', letterSpacing: '0.03em',
                                                                    }}>
                                                                        {t.speaker_tag || 'Unknown'}
                                                                    </span>
                                                                    <span style={{ color: '#334155', marginLeft: '6px' }}>
                                                                        {t.transcript}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                            {/* Auto-scroll anchor */}
                                                            <div ref={el => { if (el) el.scrollIntoView({ behavior: 'smooth' }); }} />
                                                            </>
                                                        ) : (
                                                            <div style={{ padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '0.82rem' }}>
                                                                Start speaking — your words will appear here...
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Right: Pulse (dominant) + Blinc (smaller, below).
                                                    A clear gap between them so they read as two distinct features. */}
                                                <div style={{
                                                    flex: 1, display: 'flex', flexDirection: 'column', gap: '20px',
                                                    maxWidth: '380px', minWidth: '280px', minHeight: 0,
                                                }}>
                                                    <div style={{
                                                        flex: props.facilitationEnabled ? '0 0 65%' : 1,
                                                        minHeight: 0, overflow: 'hidden',
                                                    }}>
                                                        <DiscussionPulsePanel
                                                            sessionDeviceId={props.sessionDevice.id}
                                                            isSessionActive={true}
                                                            fill={true}
                                                        />
                                                    </div>
                                                    {props.facilitationEnabled && (
                                                        <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                                                            <FacilitationPanel
                                                                sessionDeviceId={props.sessionDevice.id}
                                                                socket={props.socket}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="center-column-container" style={{
                                            // Hide this container entirely when none of its
                                            // children render — otherwise it takes blank vertical
                                            // space via flex-grow even with no content.
                                            display: (
                                                (props.speakerMode === "auto" && props.speakers?.length > 0 && !props.facilitationEnabled)
                                                || props.joinwith === "Video"
                                                || props.joinwith === "Videocartoonify"
                                            ) ? undefined : 'none',
                                        }}>
                                            {/* Mode A: Speaker rename panel during recording (below main view) */}
                                            {props.speakerMode === "auto" && props.speakers?.length > 0 && !props.facilitationEnabled && (
                                                <AppSectionBoxComponent heading={"Speakers:"}>
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "4px 0" }}>
                                                        {props.speakers.map((speaker, i) => (
                                                            <div key={speaker.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "4px 8px", borderRadius: "6px", background: "#f5f5f5" }}>
                                                                <span style={{ fontSize: "14px" }}>{speaker.alias || `Speaker ${i}`}</span>
                                                                <button
                                                                    style={{ fontSize: "12px", padding: "2px 10px", borderRadius: "4px", border: "1px solid #ccc", background: "#fff", cursor: "pointer" }}
                                                                    onClick={() => props.openForms("renameAlias", speaker)}
                                                                >
                                                                    Rename
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </AppSectionBoxComponent>
                                            )}

                                            {props.joinwith === "Video" && (
                                                <AppSectionBoxComponent
                                                    heading={"Video control:"}
                                                >
                                                    <div
                                                        className={
                                                            style[
                                                                "video-container"
                                                            ]
                                                        }
                                                        style={{
                                                            display:
                                                                props.preview
                                                                    ? "block"
                                                                    : "none",
                                                        }}
                                                    >
                                                        <video
                                                            controls={true}
                                                            muted={true}
                                                            style={{
                                                                marginLeft:
                                                                    "20px",
                                                            }}
                                                        />
                                                    </div>
                                                </AppSectionBoxComponent>
                                            )}

                                            {props.joinwith ===
                                                "Videocartoonify" && (
                                                <AppSectionBoxComponent
                                                    heading={"Video control:"}
                                                >
                                                    <div
                                                        className={
                                                            style[
                                                                "video-container"
                                                            ]
                                                        }
                                                        style={{
                                                            display:
                                                                props.preview
                                                                    ? "block"
                                                                    : "none",
                                                        }}
                                                    >
                                                        <video
                                                            controls={true}
                                                            muted={true}
                                                            style={{
                                                                marginLeft:
                                                                    "20px",
                                                            }}
                                                        />
                                                        <img
                                                            style={{
                                                                marginLeft:
                                                                    "12px",
                                                            }}
                                                            width="150"
                                                            height="80"
                                                            src={
                                                                props.cartoonImgUrl
                                                            }
                                                        />
                                                    </div>
                                                </AppSectionBoxComponent>
                                            )}
                                        </div>
                                        {props.loading() ? (
                                            <AppSpinner></AppSpinner>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </>
                            )}
                    </div>
                )}

            <GenericDialogBox
                show={
                    props.currentForm !== "" &&
                    props.currentForm !== "gottoselectedtranscript" &&
                    props.currentForm !== "gototranscript"
                }
            >
                {(props.currentForm === "Transcript" && (
                    <div className={style2["dialog-content"]}>
                        <div className={style2["dialog-heading"]}>
                            Transcript
                        </div>
                        <div className={style2["dialog-body"]}>
                            {props.currentTranscript.transcript}
                        </div>
                        <div className={style2["dialog-button-container"]}>
                            <button
                                className={`${style2["dialog-button"]} ${style2["right-button"]}`}
                                onClick={props.closeDialog}
                            >
                                Close
                            </button>
                            <button
                                className={`${style2["dialog-button"]} ${style2["left-button"]}`}
                                onClick={props.seeAllTranscripts}
                            >
                                View All
                            </button>
                        </div>
                    </div>
                )) ||
                    (props.currentForm === "Options" && (
                        <div className={style2["dialog-content"]}>
                            <div className={style2["dialog-heading"]}>
                                Session Options
                            </div>
                            <button
                                className={style2["basic-button"]}
                                onClick={props.togglePreview}
                            >
                                {props.previewLabel}
                            </button>
                            <button
                                className={style2["cancel-button"]}
                                onClick={props.closeDialog}
                            >
                                Cancel
                            </button>
                        </div>
                    )) ||
                    (props.currentForm === "fingerprintAudio" && (
                        <div className="min-w-{300px} flex h-60 flex-col items-center justify-around text-center sm:h-70">
                            <div className="sans text-base/normal font-bold sm:text-xl/loose">
                                Record Speaker Fingerprint:
                            </div>
                            <VoiceRecorder
                                onAudioDownload={props.saveAudioFingerprint}
                                downloadable={false}
                                uploadAudioFile={false}
                                width="100%"
                                mainContainerStyle={{
                                    "margin-right": "auto",
                                    "margin-left": "auto",
                                }}
                                controllerContainerStyle={{ height: "3rem" }}
                            />
                            <button
                                className="toolbar-button z-40"
                                onClick={props.addSpeakerFingerprint}
                            >
                                Confirm
                            </button>
                            <button
                                className={style2["cancel-button"]}
                                onClick={props.closeDialog}
                            >
                                Cancel
                            </button>
                        </div>
                    )) ||
                    (props.currentForm === "renameAlias" && (
                        <div
                            className={style5["dialog-window"]}
                            style={{ "min-width": adjDim(270) + "px" }}
                        >
                            <div className={style5["dialog-heading"]}>
                                Update Alias Name:
                            </div>
                            <input
                                id="txtAlias"
                                defaultValue={props.selectedSpeaker.alias}
                                className={style5["field-input"]}
                                maxLength="64"
                            />
                            <div>
                                {props.invalidName
                                    ? "Your proposed rename is invalid."
                                    : ""}
                            </div>
                            <button
                                className={style5["basic-button"]}
                                onClick={() => {
                                    props.changeAliasName(
                                        document.getElementById("txtAlias")
                                            .value,
                                    )
                                }}
                            >
                                {" "}
                                Confirm
                            </button>
                            <button
                                className={style5["cancel-button"]}
                                onClick={props.closeDialog}
                            >
                                {" "}
                                Cancel
                            </button>
                        </div>
                    ))}
            </GenericDialogBox>

            <DialogBoxTwoOption
                show={props.currentForm === "NavGuard"}
                itsclass={style["dialog-window"]}
                heading={"Stop Recording"}
                body={
                    "Leaving this page will stop recording. Are you sure you want to continue?"
                }
                deletebuttonaction={() => props.navigateToLogin(true)}
                cancelbuttonaction={props.closeDialog}
            />

            <DialogBox
                itsclass={"add-dialog"}
                heading={"Failed to Join"}
                message={props.displayText}
                show={props.currentForm === "JoinError"}
                closedialog={props.closeDialog}
            />

            <DialogBox
                itsclass={"add-dialog"}
                heading={"Missing Speaker Fingerprints"}
                message={props.displayText}
                show={props.currentForm === "FingerprintingError"}
                closedialog={props.closeDialog}
            />

            {/* Post-discussion artifacts view (replaces QR code dialog) */}
            {props.currentForm === "ClosedSession" && props.prevSessionDeviceId > 0 && (
                <PostDiscussionArtifacts
                    sessionDeviceId={props.prevSessionDeviceId}
                    sessionId={props.prevSessionId}
                    speakerMode={props.speakerMode}
                    onClose={props.closeDialog}
                    socket={props.socket}
                    canFinalize={true}
                />
            )}
            {/* Fallback: old QR code dialog if no device ID available */}
            {props.currentForm === "ClosedSession" && !(props.prevSessionDeviceId > 0) && (
                <GenericDialogBox
                    itsclass={"add-dialog small-section"}
                    heading={"Discussion Closed"}
                    show={true}
                >
                    <div className="text-xl/loose font-sans font-bold m-2">Discussion Closed</div>
                    <div className="text-base font-sans font-normal m-2">{props.displayText}</div>
                    <SessionQRCode sessionId={props.prevSessionId} />
                    <button className="option-button font-sans small-section bg-red-500 hover:bg-red-400 m-2" onClick={props.closeDialog}>Close</button>
                </GenericDialogBox>
            )}

            <WaitingDialog
                itsclass={"add-dialog"}
                heading={"Connecting..."}
                message={"Please wait..."}
                show={props.currentForm === "Connecting"}
            />

            <DialogBox
                itsclass={"add-dialog"}
                heading={"Error"}
                message={props.alertMessage}
                show={props.showAlert}
                closedialog={props.closeAlert}
            />
        </>
    )
}

export { ByodJoinPage }
